import * as React from 'react';

import { translate } from '~l10n/client';

import { IconCopyTo } from '~shared/components/icons/standard';
import { useWorkspacePermissionsV2 } from '~teacher/hook/workspaces';

import { WorkspaceRole } from '../../../../../api/workspaces/getWorkspaceMembers';
import { WorkspaceQuiz } from '../../../../../api/workspaces/quiz/types';

export function useCopyToAction(workspaceId: string) {
  const {
    permissions: { copyToAnotherWorkspace: canCopyToAnotherWorkspace },
    roleQuery,
  } = useWorkspacePermissionsV2({ workspaceId });
  // handler for copying to workspace
  const [isCopyQuizDialogOpen, setIsCopyQuizDialogOpen] = React.useState(false);
  const [quizIdsToCopy, setQuizIdsToCopy] = React.useState<string[]>([]);

  const copyToAction = React.useMemo(
    () => ({
      key: 'copy-to',
      title: translate('Copy To Shared Library'),
      icon: <IconCopyTo />,
      action: ({ data, close }) => {
        setIsCopyQuizDialogOpen(true);
        const workspaceQuizIds = data.map(
          (workspaceQuiz: WorkspaceQuiz) => workspaceQuiz.id
        );
        setQuizIdsToCopy(workspaceQuizIds);
        close();
      },
      disabled: () => !canCopyToAnotherWorkspace,
      constraint: ({ data }) => {
        if (roleQuery.data === WorkspaceRole.Viewer) return false;

        return data.every((item) => item.type === 'quiz');
      },
      showProBadge: !canCopyToAnotherWorkspace,
    }),
    [canCopyToAnotherWorkspace, roleQuery.data]
  );
  return {
    isCopyQuizDialogOpen,
    setIsCopyQuizDialogOpen,
    quizIdsToCopy,
    copyToAction,
  };
}
